import { render, staticRenderFns } from "./campProblemsList.vue?vue&type=template&id=04387774&scoped=true&"
import script from "./campProblemsList.vue?vue&type=script&lang=js&"
export * from "./campProblemsList.vue?vue&type=script&lang=js&"
import style0 from "./campProblemsList.vue?vue&type=style&index=0&id=04387774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04387774",
  null
  
)

export default component.exports